<select class="form-control" [(ngModel)]="choosenStatus" (change)="changeDeskStatus()">
    <option [ngValue]="DeskStatus.Open">{{ 'console.open' | translate }}</option>
    <option [ngValue]="DeskStatus.Closed">{{ 'console.closed' | translate }}</option>
    <option [ngValue]="DeskStatus.Pause">{{ 'console.break-status' | translate }}</option>
</select>
